import { ApolloClient, gql } from 'apollo-boost';
import { Report } from './utils';
import { ContributionEligibility } from 'npo/pages/ReportsBeta/ContributionEligibility/ContributionEligibilitySelector';

const updateProgramMutation = gql`
  mutation program(
    $id: Int!
    $managerId: Int!
    $name: String
    $level1Note: String
    $contributionEligibility: String
  ) {
    updateProgram(
      id: $id
      managerId: $managerId
      name: $name
      level1Note: $level1Note
      contributionEligibility: $contributionEligibility
    ) {
      success
    }
  }
`;

export const updateProgram = (
  client: ApolloClient<object>,
  programId: Report['programId'],
  managerId: number | string,
  programName?: string,
  level1Note?: string,
  contributionEligibility?: ContributionEligibility | null,
) => {
  return client.mutate({
    mutation: updateProgramMutation,
    variables: {
      id: programId,
      managerId,
      name: programName,
      level1Note,
      contributionEligibility,
    },
    fetchPolicy: 'no-cache',
  });
};

const getProgramManagerQuery = gql`
  query allPrograms($id: ID) {
    allPrograms(filters: { id: $id }) {
      edges {
        node {
          managerId
          managers
          manager {
            accountId
            firstName
            lastName
            email
            phone
            title
          }
        }
      }
    }
  }
`;

export interface ProgramManagers {
  managerId: number;
  manager: {
    title: string | null;
    phone: string | null;
    email: string | null;
    lastName: string | null;
    accountId: number;
    firstName: string | null;
  };
  managers: {
    id: number;
    email: string;
    first_name: string | null;
    last_name: string | null;
    title: string | null;
    phone: string | null;
    accountId: number;
  }[];
}

export const getProgramManager = (
  client: ApolloClient<object>,
  reportId: Report['dbId'],
  programId: Report['programId'],
) => {
  return client.query({
    query: getProgramManagerQuery,
    variables: {
      id: programId,
      // reportId,
    },
    fetchPolicy: 'no-cache',
  });
};
